export class ResponseFormatError extends Error {
  name = 'SCP_RESPONSE_FORMAT_ERROR' as const;

  public constructor(response: unknown) {
    super(`Invalid SCP response format: ${JSON.stringify(response)}`);
  }
}
